<template>
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">Property Type</h5>
            <template v-if="status.statisticSummary">
                <apexchart
                    v-if="series.some(item => item > 0)"
                    type="pie"
                    height="200"
                    :options="chartOptions"
                    :series="series"
                />
                <b-alert v-else show variant="warning" class="text-center">
                    <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                </b-alert>
            </template>
            <div v-else class="d-flex justify-content-center align-items-center" style="height: 200px;">
                <b-spinner variant="info" role="status"></b-spinner>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { propertyTypeMethods } from "@/state/api";
import { PROPERTY_TYPE_MODULE } from "@/state/api/propertyType.state";

export default {
    created() {
        this.getPropertyTypeStatisticSummary();
    },
    methods: {
        ...propertyTypeMethods,
    },
    computed: {
        ...mapState(PROPERTY_TYPE_MODULE, ['status']),
        statisticSummary() {
            return this.$store.state.api.propertyType.statisticSummary || [];
        },
        series() {
            return this.statisticSummary.map(item => Number(item.value) || 0);
        },
        chartOptions() {
            return {
                labels: this.statisticSummary.map(item => item.name),
                legend: {
                    position: 'right',
                    horizontalAlign: 'center',
                },
                colors: ['#556ee6', '#34c38f', '#f1b44c', '#f46a6a', '#50a5f1'],
            };
        },
    },
}
</script>
